<template>
  <div class="menu-modal" :class="{ open: isMenuOpen }">
    <button class="menu-close" v-on:click="onClose">
      <img src="../assets/menu-close.svg" />
    </button>
    <h2 class="menu-title">Menu</h2>
    <nav class="menu">
      <NavItem
        to="/about"
        alt="about kao chaio"
        :icon="require('../assets/about.svg')"
      >
        關於高僑
      </NavItem>
      <NavItem
        to="/course-planning"
        alt="course planning"
        :icon="require('../assets/planning.svg')"
      >
        課程介紹
      </NavItem>
      <NavItem
        to="/course-schedule"
        alt="course schedule"
        :icon="require('../assets/timetable.svg')"
      >
        課程時段表
      </NavItem>
      <NavItem
        to="/rank"
        alt="kao chaio rank list"
        :icon="require('../assets/rank-list.svg')"
      >
        升學榮譽榜
      </NavItem>
      <NavItem
        to="/schedule"
        alt="important schedule"
        :icon="require('../assets/schedule.svg')"
      >
        行事曆
      </NavItem>
    </nav>
    <nav class="labels">
      <a
        class="label olive-green"
        target="_blank"
        href="https://www.kctest.kaochiao.com.tw/%E9%A6%96%E9%A0%81"
      >
        高僑盃
      </a>
      <router-link class="label olive-green" to="/join-us">
        人才招募
      </router-link>
      <a
        class="label olive-green"
        target="_blank"
        href="https://fc.kaochiao.com.tw"
      >
        加盟高僑
      </a>
      <a
        class="label red"
        target="_blank"
        href="https://forms.gle/NdFt93SQWz7tRyAs5"
      >
        申請試聽
      </a>
      <router-link class="label olive-green" to="/"> 回首頁 </router-link>
    </nav>
    <nav class="socials">
      <a target="_blank" :href="facebookUrl">
        <img src="../assets/fb-grey.svg" />
      </a>
      <a target="_blank" href="https://line.me/R/ti/p/%40bzh1686u">
        <img src="../assets/line-grey.svg" />
      </a>
    </nav>
    <div class="call">
      <a href="tel:04-2389-2887">
        <img src="../assets/call.svg" />
      </a>
      <p>南屯校 04-2389-2887</p>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

import NavItem from '@/components/NavItem.vue';

export default {
  components: {
    NavItem,
  },
  props: {
    isMenuOpen: Boolean,
  },
  computed: {
    facebookUrl() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 'fb://page/?id=572806189534034';
      } else if (/(Android)/i.test(navigator.userAgent)) {
        return 'fb://page/572806189534034';
      } else {
        return 'https://www.facebook.com/kaochiao23892887/';
      }
    },
  },
  methods: {
    handlePressedKaoChiaoCup() {
      Swal.fire({
        text: '功能尚未開放，敬請期待',
        customClass: {
          container: 'swal',
        },
      });
    },
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style>
.swal {
  z-index: 999;
}
</style>

<style lang="scss" scpoed>
.menu-modal {
  display: flex;
  flex-direction: row;
  flex: 1;

  .menu-title {
    display: none;
  }

  nav {
    display: flex;
    &.menu {
      flex: 1;
      align-items: flex-end;
      justify-content: space-around;
    }
    &.labels {
      margin-left: 15px;
      margin-top: 19px;
      align-items: flex-start;
      a {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &.socials {
      display: none;
    }
  }

  .label {
    text-decoration: none;
    border-radius: 11px;
    width: 85px;
    padding: 7px 0;
    color: white;
    font-size: 14px;
    text-align: center;
    font-weight: bold;

    &.olive-green {
      background-color: #c4cb7a;
    }
    &.red {
      background-color: #e06960;
    }
  }

  .menu-close {
    display: none;
  }

  .call {
    display: none;

    img {
      width: 155px;
    }
  }

  .menu-bar {
    display: none;

    .menu-title {
      display: none;
    }
  }
}

@media (max-width: 1023px) {
  .menu-modal {
    transform: translate3d(0, 0, 0);
    z-index: 5;
    display: none !important;
    position: fixed;
    background: rgba(255, 255, 255, 0.9);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: visible;

    &.open {
      display: block !important;
    }

    .menu-title {
      display: block !important;
      text-align: center;
      border-bottom: 2px solid #c4cb7a;
      padding-bottom: 13px;
      margin: 30px 25px 0;
    }

    .logo {
      height: 33px;
    }

    .menu {
      display: flex;
      flex-direction: column;
      align-items: center !important;

      a {
        flex-direction: row !important;
        align-items: center !important;
        &:before {
          content: '';
          display: inline-block;
          background: url('../assets/joined-school-list-blue.svg') center center
            no-repeat;
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }

        &:nth-child(even):before {
          background-image: url('../assets/joined-school-list-yellow.svg');
        }
      }
    }

    .labels {
      display: grid !important;
      grid-template-areas:
        '. .'
        '. .';
      justify-content: center;
      grid-gap: 10px;
    }

    .socials {
      margin-top: 20px;
      display: grid !important;
      grid-template-areas: '. .';
      justify-content: center;
      grid-gap: 60px;
    }

    .menu-close {
      cursor: pointer;
      border: none;
      background: transparent;
      display: block !important;
      position: absolute;
      top: 9px;
      right: 5px;
    }
  }
}
</style>
